import { useEffect, useState } from 'react'
import SocialLinks from './SocialLinks'

import './App.css'
import Footer from './Footer'

const chrisAvatar = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-intro-video-3.gif"
const onsiteLogo = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png"
const car1 = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-intro-video-4.gif"


function App(props) {

  const [isMobile, setIsMobile] = useState(/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent));

  const handleVCardDownload = () => {
    setTimeout(() => {
      window.open('https://dot.cards/chrisonsitedetailing', '_blank');
    }, 300);
  };


function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isIOSDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
}

function isAndroidDevice() {
  return /Android/i.test(navigator.userAgent);
}

useEffect(() => {
  setIsMobile(window.innerWidth <= 768);
  if (props.zoomTo) {
    const element1 = document.getElementById(props.zoomTo);
    const element2 = document.getElementById('info-section');
    if (element1) {
      element1.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        element2.scrollBy({ top: 230, left: 0, behavior: 'smooth' }); // 50px padding above
      }, 300);
    }
  }
}, [props.zoomTo]);

const phoneNumber = "+19493234900";

let linkPrefix = "";
let bodyText = "Hello, I am interested in your auto detailing services.";

if(isMobileDevice()) {
  if(isAndroidDevice()) {
    linkPrefix = "smsto:";
  } else {
    linkPrefix = "sms://";
  }
} else {
  linkPrefix = "sms://";
}


const handleCallChris = () => {
  // Google Ads click-to-call tracking
  if (typeof window.gtag_report_conversion === 'function') {
    window.gtag_report_conversion(`tel:${phoneNumber}`);
  } else {
    // fallback if gtag_report_conversion is not loaded
    window.location.href = `tel:${phoneNumber}`;
  }
}

let smsLinkURLToSendOnClick = encodeURI(linkPrefix+phoneNumber+"?body="+bodyText);

const openMessengerApp = (bodyText) => {
  setTimeout(() => {
    let theBodyText = `&body=${bodyText}`;
    window.open(smsLinkURLToSendOnClick+theBodyText, "_self");
  }, 300);
}

const handleScheduleClick = () => {
  setTimeout(() => {
    window.open("https://calendly.com/chris-c-solutionsauto/detailing-carwash", "_blank");
  }, 300);
}

const handleServiceMenuClick = () => {
  setTimeout(() => {
    window.open("/menu", "_self");
  }, 300);
}

const handleLeaveReviewClick = () => {
  setTimeout(() => {
    window.open("https://g.page/r/CU_KKJnOvrS1EAI/review", "_blank")
  }, 300);
}

  return (
    <>
      <div className="card">
        <section className="header">
          <div className="logo">
            <img src={onsiteLogo} alt="Chris Onsite Cars logo" />
          </div>

          <div className="avatar">
            <img src={chrisAvatar} alt="Chris H. Profile Picture" />
          </div>

          <div className="car">
            <img src={car1} alt="Detailed Car" />
          </div>
      </section>
      <section id="info-section" className="info-section">
        <div className="name title">
          Chris H.
        </div>

        <h1 className="title">On-Site Auto Detailing</h1>

        <div className="actions">
            <div className="action-btn" onClick={() => openMessengerApp("Hello, I am interested in your auto detailing services.")}>
              Text
            </div>
            
            <div id="call-chris" className="action-btn" onClick={handleCallChris}>
              Call
            </div>

            <div className="action-btn" onClick={handleScheduleClick}>
              Schedule
            </div>

            {!isMobile && <div id="add-contact" className="action-btn" onClick={handleVCardDownload}>
              Add Contact
            </div>}
        </div>

        <div style={{ fontSize: "14px", maxWidth: "600px", margin: "20px auto", textAlign: "center" }}>
          <p>
            By texting or calling Chris OnSite Auto Detailing, you consent to receive SMS messages related to appointment scheduling, service updates, and occasional promotions.
            Message frequency is contigent on user engagement and promotions will not exceed once per month. Message and data rates may apply.
            Reply STOP to unsubscribe. Reply HELP for assistance.
          </p>
        </div>

        <h2 className="sub-title">
          Every Detail Counts
        </h2>

        <div className="headlines">
          Interior & Exterior Restoration · Paint Correction · Polishing · Ceramic Coatings · Rim Repair · Headlight Restoration · Scratch Removal
        </div>
        
        {isMobile && (
          <div style={{ margin: "0 auto", display: "flex", justifyContent: "center" }}>
            <div id="add-contact" className="action-btn add-contact" onClick={handleVCardDownload}>
              Add Contact
            </div>
          </div>
        )}
        <h3 className="title">
          Automotive Specialist
        </h3>

        <div className="location">
          Location: &nbsp;
          <a href="https://maps.app.goo.gl/fvMPVDhNsjyPG6JN7" target="_blank" rel="noopener noreferrer">
            Dana Point, California</a>, <a href="https://maps.app.goo.gl/28wkajrNvwDfQof26" target="_blank" rel="noopener noreferrer">
            Laguna Beach, California</a>, <a href="https://maps.app.goo.gl/a1c1yEgxeCv9Etpw7" target="_blank" rel="noopener noreferrer">
            Newport Beach, California</a>, <a href="https://maps.app.goo.gl/W2o4fJa2srrLZYuY9" target="_blank" rel="noopener noreferrer">
            Irvine, California</a>, <a href="https://maps.app.goo.gl/edvpFVa4Ny3yW5Ey8" target="_blank" rel="noopener noreferrer">
            Laguna Niguel, California</a>, <a href="https://maps.app.goo.gl/5c3TrEcbc5cpaLju9" target="_blank" rel="noopener noreferrer">
            Mission Viejo, California</a>, <a href="https://maps.app.goo.gl/Zcyz5DfWrTWKseLU6" target="_blank" rel="noopener noreferrer">
            San Juan Capistrano, California</a>
        </div>
          
        <div style={{ margin: "50px auto", display: "flex", flexDirection: "row", alignItems: "center" }}>
          <div id="venmo-me" className="socials" onClick={() => window.open("https://venmo.com/u/chrisonsite_detailing", "_blank")}>
              <h2 className="title">Venmo Me</h2>
              <div className="payment-options">
                <div className="payment-option" style={{cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center"}}>
                  <img style={{width: "50px"}} src="https://upload.wikimedia.org/wikipedia/commons/8/84/Venmo_logo.png" />
                  <span style={{fontSize: "14px"}}>Venmo</span>
                </div>
              </div>
            </div>
            <div id="serviceBtnContainer" className="socials" onClick={handleServiceMenuClick}>
              <div id="serviceMenu" className="action-btn">
                  <span>Service Menu</span>
              </div>
            </div>
            <div id="view-instagram" className="socials" onClick={() => window.open("https://www.instagram.com/chrisonsitedetailing", "_blank")}>
              <h2 className="title">Friends?</h2>
                <div className="payment-options">
                  <div className="payment-option" style={{cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <SocialLinks platform="instagram" size={50} />
                    <span style={{fontSize: "14px"}}>Instagram</span>
                  </div>
                </div>
            </div>
        </div>

        <div id="leave-a-review" style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <div className="leave-review-btn" onClick={handleLeaveReviewClick}>
            <h3 className="emoji">Leave Review!</h3>
          </div>
        </div>

      </section>
    </div>
    <Footer />
  </>
  )
}

export default App
